import { isNil } from "lodash";
import { useState } from "react";
import { MdOutlineFolderOpen, MdOutlineHealthAndSafety } from "react-icons/md";
import format from "string-template";
import Button from "shared/components/Button";
import RangeDrawer from "./RangeDrawer";

const ProductHeader = ({ translation: T, vintage, documents }) => {
  const [documentsOpen, setDocumentsOpen] = useState(false);

  return (
    <>
      <div className="ac-collectif__product">
        <div className="ac-collectif__product-identity">
          <span className="ac-collectif__product-icon">
            <MdOutlineHealthAndSafety size={26} />
          </span>
          <div className="ac-collectif__product-naming">
            <h3 className="ac-collectif__product-name">{T.PRODUCT.RANGE}</h3>
            <p className="ac-collectif__product-subtitle">
              {isNil(vintage)
                ? T.OFFER.PRODUCT.SUBTITLE_PENDING
                : format(T.OFFER.PRODUCT.SUBTITLE, { vintage })}
            </p>
          </div>
        </div>
        <Button type="secondary--light" onClick={() => setDocumentsOpen(true)}>
          <MdOutlineFolderOpen size={16} />
          {T.OFFER.PRODUCT.VIEW_RANGE}
        </Button>
      </div>
      <RangeDrawer
        translation={T}
        documents={documents}
        open={documentsOpen}
        onClose={() => setDocumentsOpen(false)}
      />
    </>
  );
};

export default ProductHeader;
